var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 49 32",
    enableBackground: "new 0 0 49 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M37.088,8.861L36.486,9c-0.033,0-0.066,0-0.098,0c-0.029-0.053-0.064-0.099-0.109-0.137 c-1.598-4.932-6.346-8.72-11.742-8.72c-6.791,0-12.315,5.391-12.315,12.194c0,0.058,0,0.116,0.001,0.174 c-1.417-0.286-2.891-0.263-4.335,0.064c-4.067,0.922-7.019,3.875-7.704,7.706c-0.533,2.981,0.206,5.856,2.081,8.096 C4.193,30.68,7.086,32,10.203,32h26.426c6.629,0,11.929-4.616,12.328-10.785c0.212-3.282-0.88-6.345-3.076-8.688 C43.654,10.152,40.45,8.861,37.088,8.861z M47.959,21.114C47.595,26.75,42.724,31,36.629,31H10.203c-2.82,0-5.434-1.189-7.17-3.265 c-1.681-2.009-2.343-4.593-1.863-7.278c0.613-3.429,3.272-6.075,6.94-6.907c0.7-0.158,1.409-0.238,2.108-0.238 c0.812,0,1.62,0.107,2.403,0.32c0.156,0.044,0.322,0.008,0.447-0.096c0.125-0.103,0.193-0.259,0.183-0.42 c-0.017-0.255-0.029-0.521-0.029-0.779C13.222,6.086,18.297,1,24.537,1c5.13,0,9.626,3.437,10.934,8.357 c0.48,1.956,0.42,4.155-0.164,6.037c-0.082,0.264,0.065,0.544,0.329,0.626c0.05,0.016,0.1,0.022,0.148,0.022 c0.213,0,0.411-0.138,0.478-0.352c0.579-1.865,0.66-4.005,0.282-5.978l0.544,0.004c3.132,0,5.995,1.215,8.063,3.421 C47.156,15.278,48.153,18.11,47.959,21.114z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8d2c33e6.svg";
export { ForwardRef as ReactComponent };